<header>
	<pv-toolbar [backAction]="['/home']" [title]="'syncActions.title' | translate" />
</header>

<ul>
	@for (action of (actions$ | async) || []; track action) {
		@switch (action | actionType) {
			@case ("action") {
				<li>
					<ic-sync-action-item [syncAction]="action" />
				</li>
			}

			@case ("file") {
				<li>
					<ic-cached-file-item [cachedFile]="action" />
				</li>
			}

			@case ("event") {
				<li>
					<ic-app-event-item [appEvent]="action" />
				</li>
			}
		}
	}
</ul>
